export default "__VITE_ASSET__C7q_9kG$__"